import { useContext } from 'react';

import { MediaLibrarySettingsContext } from '~modules/media-library/context/MediaLibrarySettings';

export default function useMediaLibrarySettings() {
  const context = useContext(MediaLibrarySettingsContext);
  if (!context) {
    throw new Error(`useMediaLibrarySettings must be used within a MediaLibrarySettingsProvider`);
  }
  return context;
}
